import { WarrantEntity } from 'types/WarrantEntity'

export const getWarrantLabel = ({ instrumentSymbol, name }: Pick<WarrantEntity, 'instrumentSymbol' | 'name'>) =>
    `Teckningsoption ${instrumentSymbol || name}`
